import React from "react";
import aboutus from '../assects/aboutus.jpg'
import objective from '../assects/5.jpg'
// import world from './world-environment-earth-day-concept-generative-ai(1).jpg'

import styles from './Aboutus.module.css';

const Aboutus = () => {
    return (
        <div id={styles.aboutus}>
            <div className={styles.aboutus}>
                <div className={styles.aboutheading}>
                    <h1 className={styles.abouthead}>ABOUT US</h1>
                </div>
                <div className={styles.aboutContaint}>
                    <div className={styles.aboutImage}>
                        <img src={aboutus} alt="About Company" />
                    </div>
                    <div className={styles.aboutText}>
                        <p>Forest Wellness is a health and wellness brand dedicated to offering a natural path to well-being
                            through its range of high-quality, organic products. Specializing in the cultivation and sale of
                            powerful superfoods like Ashwagandha, Moringa, and Stevia, Forest Wellness harnesses the purity and
                            potency of nature to enhance physical, mental, and emotional health. Committed to sustainability and
                            ethical sourcing, each product is carefully selected and processed to retain its nutritional benefits,
                            ensuring customers receive the finest nature has to offer. Ideal for health-conscious individuals seeking
                            organic alternatives to supplement their diet, Forest Wellness stands at the forefront of natural wellness,
                            providing solutions that nurture the body, mind, and spirit.</p>
                    </div>
                </div>
            </div>
            <div className={styles.objective}>
                <div className={styles.ourObjective}>
                    <img  src={objective} alt=""/>
                </div>
            </div>
        </div>
    );
}

export default Aboutus;